import { render } from "./CSurveyTest.vue?vue&type=template&id=12bbc2b2&scoped=true&ts=true"
import script from "./CSurveyTest.ts?vue&type=script&lang=ts"
export * from "./CSurveyTest.ts?vue&type=script&lang=ts"

import "./CSurveyTest.scss?vue&type=style&index=0&id=12bbc2b2&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bbc2b2"]])

export default __exports__